<template>
  <v-container class="ma-0 pa-0 mw-100">
    <validation-dialog
      :title="$t('AdminPage.Disable_Token')"
      :content="$t('AdminPage.Disable_Token_Content')"
      :dialog="disableTokenDialog"
      @close=";(disableTokenDialog = false), (selectedToken = '')"
      @done="disableToken"
      :buttons="[$t('Headers.cancel'), $t('Headers.disable')]"
    />
    <validation-dialog
      :title="$t('AdminPage.ApiKey')"
      :content="$t('AdminPage.CurrentApiKeyText') + '\n' + apiKeySelected.key"
      :dialog="showCurrentApiKeyDialog"
      @close=";(showCurrentApiKeyDialog = false), (apiKeySelected = '')"
      @done="
        ;(showNewApiKeyConfirmDialog = true), (showCurrentApiKeyDialog = false)
      "
      :buttons="[$t('Headers.close'), $t('AdminPage.NewApiKey')]"
    />
    <validation-dialog
      :title="$t('AdminPage.NewApiKey')"
      :content="$t('AdminPage.NewApiKeyText')"
      :dialog="showNewApiKeyConfirmDialog"
      @close=";(showNewApiKeyConfirmDialog = false), (apiKeySelected = '')"
      @done="newApiKey"
      :buttons="[$t('Headers.close'), $t('AdminPage.NewApiKey')]"
    />
    <validation-dialog
      :title="$t('AdminPage.NewApiKey')"
      :content="newApiKeyFull + '\n' + $t('AdminPage.NewApiKeyCloseText')"
      :dialog="showNewApiKeyDialog"
      @close=";(showNewApiKeyDialog = false), (apiKeySelected = '')"
      @done="copyApiKey"
      :buttons="[$t('Headers.close'), $t('Headers.copy')]"
    />
    <v-dialog v-model="addNewTokenDialog" max-width="600px">
      <v-card>
        <v-card-title
          v-text="$t('AdminPage.Button_1')"
          v-if="!editTokenBoolean"
        />
        <v-card-title
          v-text="$t('AdminPage.ChangeTokenName')"
          v-if="editTokenBoolean"
        />
        <v-card-text>
          <v-text-field
            :label="$t('AdminPage.Name')"
            v-model="newTokenName"
            required
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            :text="$t('Headers.close')"
            @click="
              ;(addNewTokenDialog = false),
                (newTokenName = ''),
                (editToken = '')
            "
          />
          <custom-button
            :text="$t('Headers.save')"
            v-if="!editTokenBoolean"
            @click=";(addNewTokenDialog = false), addNewToken()"
          />
          <custom-button
            :text="$t('Headers.save')"
            v-if="editTokenBoolean"
            @click=";(addNewTokenDialog = false), editTokenName()"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container class="pa-0">
      <v-card-text class="pa-0">
        <v-sheet min-height="70vh" rounded="lg">
          <v-row class="pt-8 pb-10">
            <v-sheet
              rounded
              class="mx-auto"
              v-for="card in cards"
              :key="card.title"
            >
              <license-card
                v-if="!mobile"
                :title="card.title"
                :free="card.free"
                :used="card.used"
                :ratio="card.ratio"
              />
            </v-sheet>
          </v-row>

          <v-row class="mb-n12">
            <v-col cols="3" sm="3">
              <v-select
                :label="$t('AdminPage.State')"
                :items="states"
                v-model="state"
              ></v-select>
            </v-col>
            <v-col cols="3" sm="3" />
            <v-col cols="6" sm="6">
              <v-text-field
                :label="$t('AdminPage.Search')"
                v-model="search"
                append-icon="mdi-magnify"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-data-table
            :headers="tokenHeaders"
            :items="items"
            :item-class="rowClass"
            :search="search"
            :custom-filter="customDataTableItemsFilter"
            show-select
            v-model="selectedToken"
            item-key="name"
            class="pt-8"
          >
            <template v-slot:item.apiKey="{ item }">
              <custom-button
                :text="$t('AdminPage.ApiKey')"
                :disabled="item.state != 'active'"
                @click="
                  ;(apiKeySelected = item), (showCurrentApiKeyDialog = true)
                "
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                @click="disableTokenD(item)"
                :color="color"
                :disabled="item.state != 'active'"
                light
                icon
              >
                <v-icon> mdi-close-circle </v-icon>
              </v-btn>
              <v-btn
                @click="editTokenNameD(item)"
                :color="color"
                :disabled="item.state != 'active'"
                light
                icon
              >
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <template v-slot:item.apiKey="{ item }">
              <custom-button
                :text="$t('AdminPage.ApiKey')"
                :disabled="item.state != 'active'"
                @click="
                  ;(apiKeySelected = item), (showCurrentApiKeyDialog = true)
                "
              />
            </template>
          </v-data-table>
          <v-row class="pt-6 mx-n1">
            <v-spacer />
            <custom-button
              @click="addNewTokenDialog = true"
              :text="$t('AdminPage.Button_1')"
              :color="color"
              icon="mdi-plus-circle-outline"
            >
            </custom-button>
          </v-row>
        </v-sheet>
      </v-card-text>
    </v-container>
  </v-container>
</template>

<script>
import LicenseCard from '../../components/ui/other/LicenseCard'
import CustomButton from '../../components/ui/input/CustomButton'
import ValidationDialog from '../../components/ui/other/ValidationDialog'
import { log } from '@/helpers/logger'

export default {
  name: 'tokens',
  props: {
    items: Array,
    license: Object,
  },
  components: {
    LicenseCard,
    CustomButton,
    ValidationDialog,
  },
  data() {
    return {
      disableTokenDialog: false,
      addNewTokenDialog: false,
      showCurrentApiKeyDialog: false,
      showNewApiKeyDialog: false,
      showNewApiKeyConfirmDialog: false,
      editTokenBoolean: false,
      editToken: '',
      newTokenName: '',
      disableTokenSelected: '',
      apiKeySelected: '',
      newApiKeyFull: '',
      color: '',
      search: '',
      mobile: '',
      state: 'all',
      cards: [],
      selectedToken: [],
      info: {
        ses_signature_used: 0,
        ses_signature_free: 0,
        ses_signature_limit: 0,
        ses_signature_ratio: 0,
        aes_signature_used: 0,
        aes_signature_free: 0,
        aes_signature_limit: 0,
        aes_signature_ratio: 0,
        qes_signature_used: 0,
        qes_signature_free: 0,
        qes_signature_limit: 0,
        qes_signature_ratio: 0,
      },
      tokenHeaders: [
        {
          text: this.$t('AdminPage.Name'),
          align: 'start',
          value: 'name',
        },
        { text: this.$t('AdminPage.TokenId'), value: 'token_id' },
        { text: this.$t('AdminPage.ApiKey'), value: 'apiKey' },
        { text: this.$t('AdminPage.Api.secret'), value: 'secret' },
        {
          text: this.$t('AdminPage.CreationDate'),
          value: 'created_at',
        },
        {
          text: this.$t('AdminPage.ExpireDate'),
          value: 'expires_at',
        },
        {
          text: this.$t('AdminPage.State'),
          value: 'state',
          align: ' d-none',
          filter: (value) => {
            if (this.state == 'all') return true

            return value == this.state
          },
        },
        {
          value: 'actions',
          sortable: false,
        },
      ],
      states: [
        {
          value: 'all',
          text: this.$t('AdminPage.All'),
        },
        {
          value: 'active',
          text: this.$t('AdminPage.Active'),
        },
        {
          value: 'terminated',
          text: this.$t('AdminPage.Terminated'),
        },
      ],
    }
  },
  watch: {
    selectedToken() {
      this.adapt_values()
    },
  },
  created: function () {
    this.loading = true
    this.adapt_values()
    this.color = this.$vuetify.theme.themes.light.primary
    this.mobile = this.$vuetify.breakpoint.mdAndDown
    this.$store.commit('set_loading', false)
    this.loading = false
  },
  methods: {
    getCards() {
      this.cards = [
        {
          title: this.$t('AdminPage.SignaturesSES'),
          used: this.info.ses_signature_used,
          free: this.info.ses_signature_free,
          ratio: this.info.ses_signature_ratio,
        },
        {
          title: this.$t('AdminPage.SignaturesAES'),
          used: this.info.aes_signature_used,
          free: this.info.aes_signature_free,
          ratio: this.info.aes_signature_ratio,
        },
        {
          title: this.$t('AdminPage.SignaturesQES'),
          used: this.info.qes_signature_used,
          free: this.info.qes_signature_free,
          ratio: this.info.qes_signature_ratio,
        },
      ]
    },
    adapt_values() {
      this.info.ses_signature_limit = this.license.ses_signature_limit
      this.info.aes_signature_limit = this.license.aes_signature_limit
      this.info.qes_signature_limit = this.license.qes_signature_limit

      this.info.ses_signature_used = this.sum_selected('ses_signature_count')
      this.info.aes_signature_used = this.sum_selected('aes_signature_count')
      this.info.qes_signature_used = this.sum_selected('qes_signature_count')

      this.info.ses_signature_free =
        this.info.ses_signature_limit - this.info.ses_signature_used
      this.info.aes_signature_free =
        this.info.aes_signature_limit - this.info.aes_signature_used
      this.info.qes_signature_free =
        this.info.qes_signature_limit - this.info.qes_signature_used

      this.info.ses_signature_ratio =
        (this.info.ses_signature_used / this.info.ses_signature_limit) * 100
      this.info.aes_signature_ratio =
        (this.info.aes_signature_used / this.info.aes_signature_limit) * 100
      this.info.qes_signature_ratio =
        (this.info.qes_signature_used / this.info.qes_signature_limit) * 100

      if (Number.isNaN(this.info.ses_signature_ratio))
        this.info.ses_signature_ratio = 0
      if (Number.isNaN(this.info.aes_signature_ratio))
        this.info.aes_signature_ratio = 0
      if (Number.isNaN(this.info.qes_signature_ratio))
        this.info.qes_signature_ratio = 0

      this.getCards()
    },
    sum_selected(key) {
      return this.selectedToken.length === 0
        ? 0
        : this.selectedToken
            .map((a) => a[key])
            .reduce((a, b) => parseInt(a) + parseInt(b))
    },
    rowClass(item) {
      if (item.state == 'terminated') {
        return 'text-decoration-line-through'
      } else {
        return ''
      }
    },
    addNewToken() {
      var data = {
        id: this.license.license_id,
        name: this.newTokenName,
      }
      this.$store
        .dispatch('data/addToken', data)
        .then(() => {
          log(
            'AdminPage.Tokens.addNewToken() - add token to license ' + data.id,
            'info'
          )
        })
        .catch((err) => {
          log('AdminPage.Tokens.addNewToken() - ' + err.message, 'error')
        })
        .finally(() => {
          this.newTokenName = ''
        })
      location.reload()
    },
    copyApiKey() {
      confirm(this.$t('AdminPage.CopyMessage'))
      console.log('Copied') //WICHTIG --> Sonst wird fehler geworfen
      navigator.clipboard.writeText(this.newApiKeyFull)
    },
    disableTokenD(token) {
      this.disableTokenSelected = token
      this.disableTokenDialog = true
    },
    disableToken() {
      this.$store
        .dispatch('data/disableToken', this.disableTokenSelected.token_id)
        .then(() => {
          log(
            'AdminPage.Tokens.disableToken() - disable token ' +
              this.disableTokenSelected.token_id,
            'info'
          )
        })
        .catch((err) => {
          log('AdminPage.Tokens.disableToken() - ' + err.message, 'error')
        })
        .finally(() => {
          this.newTokenName = ''
        })
      this.disableTokenSelected = ''
      this.disableTokenDialog = false
      location.reload()
    },
    editTokenNameD(token) {
      this.editToken = token
      this.editTokenBoolean = true
      this.addNewTokenDialog = true
    },
    editTokenName() {
      var temp = { token: this.editToken, newName: this.newTokenName }
      this.$store
        .dispatch('data/updateTokenName', temp)
        .finally(() => {
          log(
            'AdminPage.Tokens.editTokenName() - update token name ' +
              temp.token.token_id,
            'info'
          )
          this.newTokenName = ''
        })
        .catch((err) => {
          log('AdminPage.Tokens.editTokenName() - ' + err.message, 'error')
        })
      this.editToken = ''
      this.addNewTokenDialog = false
      location.reload()
    },
    customDataTableItemsFilter(value, search, items) {
      const wordArray = search
        .toString()
        .toLowerCase()
        .split(' ')
        .filter((x) => x)
      return wordArray.every((word) =>
        JSON.stringify(Object.values(items))
          .toString()
          .toLowerCase()
          .includes(word)
      )
    },
    newApiKey() {
      this.showNewApiKeyDialog = true
      this.showNewApiKeyConfirmDialog = false
      this.apiKeySelected.id = this.$store.state.auth.user.id
      this.$store
        .dispatch('data/updateTokenApiKey', this.apiKeySelected)
        .then((res) => {
          log(
            'AdminPage.Tokens.newApiKey() - update token API key ' +
              this.apiKeySelected,
            'info'
          )
          this.newApiKeyFull = res
        })
        .catch((err) => {
          log('AdminPage.Tokens.newApiKey() - ' + err.message, 'error')
        })
    },
    confirm(msg) {
      this.$store.commit('ui/set_notification', {
        display: true,
        code: msg,
        alertClass: 'red',
      })
      return false
    },
  },
}
</script>

<style scoped>
@media screen {
  .container {
    max-width: 100%;
  }
}
</style>
